export const VersionStr = '12.0.0'
const VersionParts = VersionStr.split('.')                          // ['12', '0', '0']
export const VersionMajorMinor = VersionParts.slice(0, 2).join('.') // '12.0'
export const VersionFolder = VersionStr.replaceAll('.', '')         // '1200'
export const VersionLib = VersionMajorMinor.replaceAll('.', '')     // '120'